import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { colors } from '../../styles/theme';
import { authPanelWrapperSx } from '../../Access/styles/authPanel.styles';

/** Login/registro en el host admin, sin mapa. */
export default function AdminAuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 3,
        bgcolor: colors.backgroundSurface,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ ...authPanelWrapperSx, height: 'auto', maxHeight: 'none' }}>
        <Outlet />
      </Box>
    </Box>
  );
}
